import React from 'react';
import { motion } from 'framer-motion';
import { Check, Zap, Clock, BookOpen, HelpCircle, PenTool, Gift } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  const bullets = [{
    icon: <BookOpen className="w-5 h-5" data-id="element-109" />,
    text: 'Ebook completo "Esto no es una crisis" — 10 capítulos de claridad emocional'
  }, {
    icon: <PenTool className="w-5 h-5" data-id="element-110" />,
    text: 'Guía de Reflexión Personal — 15 preguntas para ordenar lo que sentís'
  }, {
    icon: <PenTool className="w-5 h-5" data-id="element-111" />,
    text: 'Diario de Claridad Emocional — 30 días de escritura consciente'
  }, {
    icon: <HelpCircle className="w-5 h-5" data-id="element-112" />,
    text: 'Cuando no sé qué hacer — Para atravesar este momento sin forzar nada'
  }, {
    icon: <Zap className="w-5 h-5" data-id="element-113" />,
    text: 'Acceso inmediato — Empezá a leer en menos de 2 minutos'
  }, {
    icon: <Clock className="w-5 h-5" data-id="element-114" />,
    text: 'Tuyo para siempre — Releelo cuando lo necesites, sin límites'
  }];
  return <section className="py-20 bg-[#fdf6ec] relative overflow-hidden" data-id="element-115">
      {/* Top urgency ribbon */}
      <div className="absolute top-0 left-0 w-full bg-red-700 text-white text-center py-2.5 text-sm font-bold uppercase tracking-wider z-10" data-id="element-116">
        <span className="animate-pulse inline-block mr-2" data-id="element-117">🔥</span>
        Oferta especial por tiempo limitado
        <span className="animate-pulse inline-block ml-2" data-id="element-118">🔥</span>
      </div>

      <div className="max-w-3xl mx-auto px-4 pt-10" data-id="element-119">
        {/* Section heading */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-120">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-4" data-id="element-121">
            Todo lo que recibís <span className="text-red-600" data-id="element-122">hoy</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-xl mx-auto" data-id="element-123">
            Un pack completo para acompañarte en este momento. Sin vueltas, sin
            letra chica.
          </p>
        </motion.div>

        {/* Offer card */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl shadow-2xl overflow-hidden border-2 border-amber-300" data-id="element-124">
          {/* Card header */}
          <div className="bg-gradient-to-r from-amber-400 to-amber-500 p-5 text-center" data-id="element-125">
            <div className="flex items-center justify-center gap-2" data-id="element-126">
              <Gift className="w-5 h-5 text-amber-900" data-id="element-127" />
              <p className="text-amber-900 font-extrabold uppercase tracking-wider text-sm" data-id="element-128">
                Pack Completo: Libro + 3 Bonos Gratis
              </p>
            </div>
          </div>

          <div className="p-8 md:p-12" data-id="element-129">
            {/* Bullet points */}
            <div className="space-y-4 mb-10" data-id="element-130">
              {bullets.map((item, idx) => <motion.div key={idx} initial={{
              opacity: 0,
              x: -15
            }} whileInView={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: idx * 0.08
            }} viewport={{
              once: true
            }} className="flex items-start gap-3" data-id="element-131">
                  <div className="mt-0.5 bg-green-100 text-green-600 p-1.5 rounded-full flex-shrink-0" data-id="element-132">
                    <Check className="w-4 h-4" strokeWidth={3} data-id="element-133" />
                  </div>
                  <div className="flex items-start gap-2" data-id="element-134">
                    <span className="text-gray-400 mt-0.5 flex-shrink-0" data-id="element-135">
                      {item.icon}
                    </span>
                    <span className="text-gray-800 text-base md:text-lg leading-snug" data-id="element-136">
                      {item.text}
                    </span>
                  </div>
                </motion.div>)}
            </div>

            {/* Divider */}
            <div className="border-t-2 border-dashed border-gray-200 my-8" data-id="element-137"></div>

            {/* Price comparison */}
            <div className="text-center mb-8" data-id="element-138">
              <p className="text-sm text-gray-500 uppercase tracking-wider font-medium mb-3" data-id="element-139">
                Precio normal
              </p>
              <div className="relative inline-block mb-2" data-id="element-140">
                <span className="text-3xl text-gray-400 font-bold line-through decoration-red-500 decoration-[3px]" data-id="element-141">
                  $49.990 ARS
                </span>
              </div>

              <div className="mt-4 mb-2" data-id="element-142">
                <p className="text-sm text-green-700 font-bold uppercase tracking-wider mb-2" data-id="element-143">
                  Hoy pagás solamente
                </p>
                <motion.div initial={{
                scale: 0.9
              }} whileInView={{
                scale: 1
              }} viewport={{
                once: true
              }} transition={{
                type: 'spring',
                stiffness: 200,
                damping: 10
              }} data-id="element-144">
                  <span className="text-6xl md:text-7xl font-extrabold text-red-600 leading-none" data-id="element-145">
                    $19.990
                  </span>
                  <span className="text-2xl font-bold text-red-600 ml-1" data-id="element-146">
                    ARS
                  </span>
                </motion.div>
              </div>

              {/* Savings badge */}
              <motion.div animate={{
              rotate: [-1, 1, -1]
            }} transition={{
              duration: 2,
              repeat: Infinity
            }} className="inline-block bg-green-100 text-green-800 font-bold text-sm px-4 py-2 rounded-full mt-4 border border-green-200" data-id="element-147">
                💰 Ahorrás $30.000 ARS — ¡60% de descuento!
              </motion.div>
            </div>

            {/* CTA */}
            <CTAButton text="Quiero mi pack completo" subtext="Acceso inmediato • Pago 100% seguro" className="w-full" data-id="element-148" />

            {/* Trust signals */}
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4 text-xs text-gray-400" data-id="element-149">
              <span className="flex items-center gap-1" data-id="element-150">
                🔒 Pago seguro y encriptado
              </span>
              <span className="hidden sm:inline" data-id="element-151">•</span>
              <span className="flex items-center gap-1" data-id="element-152">
                📱 100% digital — Acceso inmediato
              </span>
              <span className="hidden sm:inline" data-id="element-153">•</span>
              <span className="flex items-center gap-1" data-id="element-154">
                ♻️ Tuyo para siempre
              </span>
            </div>
          </div>
        </motion.div>

        {/* Urgency note below card */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center text-sm text-gray-500 mt-6 italic" data-id="element-155">
          * Este precio y los bonos gratis pueden dejar de estar disponibles en
          cualquier momento.
        </motion.p>
      </div>
    </section>;
}